import { Route, Routes } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import PageLoading from '../../components/PageLoading'

const PlainLayout = lazy(() => import('./components/PlainLayout'))
const NotFound = lazy(() => import('../../components/NotFound'))
const FreeOffer = lazy(() => import('./views/notice/FreeOffer'))
const FreeApproaching = lazy(() => import('./views/notice/FreeApproaching'))
const FreeFull = lazy(() => import('./views/notice/FreeFull'))
const FreeOs251 = lazy(() => import('./views/notice/FreeOs251'))
const FreeOs2250 = lazy(() => import('./views/notice/FreeOs2250'))
const FreeOs22500 = lazy(() => import('./views/notice/FreeOs22500'))
const FreeHost = lazy(() => import('./views/notice/FreeHost'))
const FreeHost251 = lazy(() => import('./views/notice/FreeHost251'))
const FreeHost2250 = lazy(() => import('./views/notice/FreeHost2250'))
const FreeHost22500 = lazy(() => import('./views/notice/FreeHost22500'))
const LiteFull = lazy(() => import('./views/notice/LiteFull'))
const LiteOs2500 = lazy(() => import('./views/notice/LiteOs2500'))
const LiteOs25000 = lazy(() => import('./views/notice/LiteOs25000'))
const PlusFull = lazy(() => import('./views/notice/PlusFull'))
const PlusOs = lazy(() => import('./views/notice/PlusOs'))

export default function NoticeRouter() {
  return (
    <PlainLayout>
      <Suspense fallback={<PageLoading />}>
        <Routes>
          <Route path="upgrade" element={<FreeOffer />} />
          <Route path="offer" element={<FreeOffer />} />
          <Route path="approaching-storage" element={<FreeApproaching />} />
          <Route path="storage-is-full" element={<FreeFull />} />
          <Route path="os-251" element={<FreeOs251 />} />
          <Route path="os-2250" element={<FreeOs2250 />} />
          <Route path="os-22500" element={<FreeOs22500 />} />
          <Route path="free-host" element={<FreeHost />} />
          <Route path="free-host-251" element={<FreeHost251 />} />
          <Route path="free-host-2250" element={<FreeHost2250 />} />
          <Route path="free-host-22500" element={<FreeHost22500 />} />
          <Route path="lite-full" element={<LiteFull />} />
          <Route path="lite-os-2500" element={<LiteOs2500 />} />
          <Route path="lite-os-25000" element={<LiteOs25000 />} />
          <Route path="plus-full" element={<PlusFull />} />
          <Route path="plus-os" element={<PlusOs />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </PlainLayout>
  )
}
